 <!-- <div class="modal-header">
    <div class="title-row py-0">
      <div class="inner-page-title">Manage Metadata Uploader</div> -->
    <!-- </div> -->
    <!-- <button type="button" class="pull-right btn-close-popup mr-3" aria-label="Close" (click)="closeModal()">
      <i class="ic-close"></i>
    </button> -->
    <!-- <button type="button" class="close" (click)="closeModal()" aria-label="Close">
   <i class="ic-close"></i>
</button> -->
<!-- 
  <button mat-icon-button mat-dialog-close class="btn-close-popups"(click)="closeModal()" >
    X
  </button>
  </div> -->
  <div class="popup-containers">
 <!-- <button mat-icon-button mat-dialog-close class="btn-close-popups" >
    X
  </button> -->
  
   <div class="d-flex justify-content-between align-items-center gap-2 mb-2 me-3 mt-3">
    <h2 mat-dialog-title class="mb-3">Manage Metadata Uploader</h2>
      <a type="button" class="btn btn-primary cursor-pointor" mat-dialog-close>
        <i class="fa fa-close"></i>
      </a>
    </div>
    
    

  <!-- <div class="modal-body"> -->
      <mat-dialog-content>

    <div class="row">
      <div class="col-lg-12 mx-auto">
        <form name="metaDataForm" [formGroup]="metaDataForm" (ngSubmit)="videoCreate(metaDataForm)" novalidate>
          <div class="home-reg-wrapper me-0">
            <div class="home-reg-form">
              <div class="benefy-cmn-frm-sec">
                <div class="row mb-3">
                  <!-- <div class="col-lg-6">
                    <div class="form-group">
                      <label class="form-label">Assets Id</label>
                      <input
                        class="form-control"
                        id="assetsId"
                        placeholder="Enter Assets Id of the match"
                        type="text"
                        required
                        formControlName="assetsId"
                      />
                      <div
                        class="validation-error"
                        *ngIf="submitted && metaDataForm.get('assetsId').errors"
                      >
                      Assets Id is required
                      </div>
                    </div>
                  </div> -->

                  <div class="col-lg-6">
                    <div class="form-group">
                      <label class="form-label">Start Time</label>

                      <input class="form-control" id="startTime" placeholder="Enter Start Time of match in HH:MM:SS "
                        type="text" required formControlName="startTime"  />
                      <div class="validation-error" *ngIf="submitted && metaDataForm.get('startTime')?.errors">
                        Start Time Should be in HH:MM:SS
                      </div>
                    </div>
                  </div>

                  <div class="col-lg-6">
                    <div class="form-group">
                      <label class="form-label">Break Time</label>
                      <input class="form-control" id="endTime" placeholder="Enter Break Time of Match in HH:MM:SS"
                        type="text" required formControlName="endTime" />
                      <div class="validation-error" *ngIf="submitted && metaDataForm.get('endTime')?.errors">
                        Break Time Should be in HH:MM:SS
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row mb-3">
                  <div class="col-lg-12">
                    <div class="form-group">
                      <label class="form-label">Restart Time</label>
                      <input class="form-control" id="secondStart" placeholder="Enter Restart Time of Match in HH:MM:SS"
                        type="text" required formControlName="secondStart" />
                      <div class="validation-error" *ngIf="
                          submitted && metaDataForm.get('secondStart')?.errors
                        ">
                        Restart Time Should be in HH:MM:SS
                      </div>
                    </div>
                  </div>
                </div>

                <div class="row mb-3">
                  <div class="col-lg-6">
                    <div class="form-group">
                      <label class="form-label">F24 File</label>
                      <input class="form-control" id="f24Url" placeholder="Enter F24 file Url of Match" type="url"
                        required formControlName="f24Url" />
                      <div class="validation-error" *ngIf="submitted && metaDataForm.get('f24Url')?.errors">
                        F40 file Url is required
                      </div>
                    </div>
                  </div>

                  <div class="col-lg-6">
                    <div class="form-group">
                      <label class="form-label">F40 url</label>
                      <input class="form-control" id="f40Url" placeholder="Enter F40 file URL " type="url" required
                        formControlName="f40Url" />
                      <div class="validation-error" *ngIf="submitted && metaDataForm.get('f40Url')?.errors">
                        F40 url is required
                      </div>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <!-- 
                  <div class="col-lg-6">
                    <div class="form-group">
                      <label class="form-label">Select Club</label>
                     
                      <select
                            id="type"
                            class="form-control"
                            formControlName="club"
                          >
                          <option value="Wolves">Wolves</option>
                            <option value="Manchestor">Manchestor</option>
                            <option value="Palace">Palace</option>
                            <option value="Hostpur">Hostpur</option>
                            <option value="Wsl">Wsl</option>
                            <option value="Epl">Epl</option>
                          </select>
                      <div
                        class="validation-error"
                        *ngIf="submitted && metaDataForm.get('club').errors"
                      >
                    Club Name is required
                      </div>
                    </div>
                  </div> -->
                </div>

                <div class="row mb-3">
                  <div class="col-lg-6">
                    <div class="form-group">
                      <p class="form-check">
                        <label class="form-check-label">Active
                          <input id="isActive" type="checkbox" (change)="toggleStatus()" [checked]="isActive" />
                          <span class="checkmark"></span>
                        </label>
                      </p>
                    </div>
                  </div>

                  <div class="col-lg-6">
                    <div class="form-group">
                      <p class="form-check">
                        <label class="form-check-label">Is Uploaded On SAMMS
                          <input id="isOnLvs" type="checkbox" (change)="toggleMe()" [checked]="isPushedOnLvs" />
                          <span class="checkmark"></span>
                        </label>
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              <div class="benefy-cmn-frm-sec brdr-non">
                <div class="row mb-3">
                  <div class="col-lg-12">
                    <div class="save-btm-btn">
                      <button class="btn-cmn btn-green" type="submit"   [disabled]="isSubmitting">
                        Save
                      </button>
                      
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
      </mat-dialog-content>
      </div>

  <!-- </div> -->